import MetricChart from "./MetricChart";
import { endpoints } from "../../helpers/Endpoints";

export default function TransactionMetrics() {
  return (
    <MetricChart
      title="Transaction Metrics"
      endpoint={endpoints.getTransactionMetrics}
      queryParamKey="transaction_type"
      datasetMap={{
        all: 'ALL',
        bills: 'BILLS',
        transfer: 'TRANSFER'
      }}
    />
  );
}
